// libs
import React, {Fragment, useEffect, useState} from 'react';
// components 
import ConfirmationBox from '../../components/confirmation-box';
import FormModal from './form-modal';
import Button from 'react-bootstrap/Button';
// config & functions 
import config from '../../config';
import { getConfigType, isPageUrlHidden } from './config-types';

function Table({loadapidata, offset, list, urlaccountid, urlconfigtype, orgInfo, token, paginationNo}) {
	const [ShowFormModalBox, setShowFormModalBox] = useState(false);
    const [ShowDeleteModalBox, setShowDeleteModalBox] = useState(false);
    const [RowId, setRowId] = useState(0);
    const deleteUrl = `${config.api.generic}/config/${urlconfigtype}`;

	const handFormModal = (rid) => {
        setRowId(rid);
        setShowFormModalBox(true);
        setShowDeleteModalBox(false);
    }

    const handleDelete = (rowId) => {
        setRowId(rowId);
        setShowFormModalBox(false);
        setShowDeleteModalBox(true);
    }

    if(list && Array.isArray(list) && list.length > 0) {
        const pNo = paginationNo ? paginationNo : 1;
        const configType = getConfigType(urlconfigtype);
        const hidePageUrl = isPageUrlHidden(configType);
        return <>
            <div className="table-responsive">
                <table className="table fs-14rem">
                    <thead>
                        <tr>
                            <th style={{minWidth: '200px'}}>{hidePageUrl ? 'Config' : 'Page Url'}</th>
                            <th style={{minWidth: '80px'}}>Status</th>
                            <th style={{minWidth: '240px'}}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((data,i) => {
                            return <tr key={Math.random()}>
                                <td>{hidePageUrl ? configType.label : data?.page_url}</td>
                                <td>{(data.status && data.status === 1) ? 'Active': 'Inactive'}</td>
                                <td>
                                    <Button variant="secondary" onClick={() => handFormModal(data.pk_id)} className="fs-14rem me-4 p-0 border-0 bg-transparent text-primary">Update</Button>
                                    <Button variant="secondary" onClick={() => handleDelete(data.pk_id)} className="fs-14rem me-2 p-0 border-0 border-0 bg-transparent text-danger">Delete</Button>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
            {(ShowDeleteModalBox) ? <ConfirmationBox loadapidata={loadapidata} apidataparams={(offset == 1) ? 0 : offset} setshowdeletemodalbox={setShowDeleteModalBox} url={deleteUrl} params={{rowId: RowId, accountId: urlaccountid}} token={token} /> : null}
            {(ShowFormModalBox) ? <FormModal loadapidata={loadapidata} apidataparams={(offset == 1) ? 0 : offset} setshowformmodalbox={setShowFormModalBox} urlaccountid={urlaccountid} urlconfigtype={urlconfigtype} rowid={RowId} token={token} orginfo={orgInfo} /> : null}
        </>
    } else {
        return null;
    }
}

export default Table;